export const MODEL_UPLOAD_COLUMN = {
  NAME_PLATE: 'nameplate',
  PRODUCT_EXAMPLE: 'productExample',
}

export const MODEL_ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png']
export const MODEL_INVALID_IMAGE_TYPES = ['jpg', 'jpe', 'jfif', 'pjpeg', 'pjp']
